import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";

import { capitalize } from "@helpers/general";

import ModalStore from "./ModalAssociateStore";
import { store, setIsModalAssociateStore } from "../../../store/project";

import "./index.css";

type ModalAssociateStoreType = {
    rowData: any;
    setLimit: Function;
    setRowData: Function;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export default function ModalAssociateStore({
    rowData,
    setLimit,
    setRowData,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: ModalAssociateStoreType) {
    const { t } = useTranslation();
    const { isModalAssociateStore } = useSnapshot(store);

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz"
                isOpen={isModalAssociateStore}
            >
                <ModalHeader
                    toggle={() => {
                        setIsModalAssociateStore!(!isModalAssociateStore);
                        setRowData([]);
                    }}
                >
                    <StyledH2>
                        {capitalize(t("Associate a template to the shops"))}
                    </StyledH2>
                </ModalHeader>

                <ModalBody>
                    <ModalStore
                        rowData={rowData}
                        setIsModalAssociateStore={setIsModalAssociateStore}
                        isModalAssociateStore={isModalAssociateStore}
                        setLimit={setLimit}
                        setRowData={setRowData}
                        setIsModalLoadingOpened={setIsModalLoadingOpened}
                        setModalLoadingData={setModalLoadingData}
                    />
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}
